import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { BaseEntity } from 'yt-ng-framework';


export class RadnaKnjizica extends BaseEntity {
    constructor() {
        super();
    }
    OsobaID: number = null;
    OrgJedID: number = null;
    naziv_i_sediste_poslodavca: string = null;
    staz_meseci: number = null;
    staz_godina: number = null;
    staz_dana: number = null;
    od_datuma: NgbDate = null;
    do_datuma: NgbDate = null;
    prc_ang: number = null;
    ned_fond_sati: number = null;


    Deserialize(input: any) {
        this.ID = input.ID;
        this.OsobaID = input.OsobaID;
        this.OrgJedID = input.OrgJedID;
        this.naziv_i_sediste_poslodavca = input.naziv_i_sediste_poslodavca;
        this.staz_meseci = input.staz_meseci;
        this.staz_godina = input.staz_godina;
        this.staz_dana = input.staz_dana;
        this.od_datuma = input.od_datuma;
        this.do_datuma = input.do_datuma;
        this.prc_ang = input.prc_ang;
        this.ned_fond_sati = input.ned_fond_sati;
        return this;
    }

    Serialize(input: RadnaKnjizica) {
        return input;
    }
}
